import { render, staticRenderFns } from "./seo-card.vue?vue&type=template&id=09de7aab"
import script from "./seo-card.vue?vue&type=script&lang=js"
export * from "./seo-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports